import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'

const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr 1fr;
    gap: ${rem(40)} ${rem(20)};
  }
`

const DealSkeletonContainer = styled.div`
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  overflow: hidden;
  width: 100%;
`

const HeroSkeletonSection = styled.div`
  display: flex;
  height: ${rem(125)};

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: ${rem(170)};
  }
`

const ColourSkeletonContainer = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 60%;

  ${mediaQueryUp.tablet} {
    padding: ${rem(24)};
    width: 55%;
  }
`

const ImageSkeletonContainer = styled.div`
  width: 40%;

  ${mediaQueryUp.tablet} {
    width: 45%;
  }
`

const ContentSkeletonSection = styled.div`
  padding: ${rem(12)} 0 0;
`

const TitleLoadingBox = styled(LoadingBox)`
  width: ${rem(300)};
  height: ${rem(32)};
`

const SubtitleLoadingBox = styled(LoadingBox)`
  width: ${rem(400)};
  height: ${rem(16)};
  margin-top: ${rem(8)};
`

const LogoLoadingBox = styled(LoadingBox)`
  width: ${rem(64)};
  height: ${rem(40)};

  ${mediaQueryUp.tablet} {
    width: ${rem(84)};
  }
`

const HeadingLoadingBox = styled(LoadingBox)`
  width: ${rem(120)};
  height: ${rem(16)};
  margin-top: ${rem(8)};

  ${mediaQueryUp.tablet} {
    margin-top: 0;
  }
`

const ImageLoadingBox = styled(LoadingBox)`
  width: 100%;
  height: 100%;
`

const ContentTitleLoadingBox = styled(LoadingBox)`
  width: 80%;
  height: ${rem(20)};
`

const ContentSubtitleLoadingBox = styled(LoadingBox)`
  width: 60%;
  height: ${rem(16)};
`

function DealSkeletonItem() {
  return (
    <DealSkeletonContainer>
      <HeroSkeletonSection>
        <ColourSkeletonContainer>
          <div>
            <LogoLoadingBox />
            <HeadingLoadingBox />
          </div>
        </ColourSkeletonContainer>

        <ImageSkeletonContainer>
          <ImageLoadingBox />
        </ImageSkeletonContainer>
      </HeroSkeletonSection>

      <ContentSkeletonSection>
        <Group direction="vertical" gap={4}>
          <ContentTitleLoadingBox />
          <ContentSubtitleLoadingBox />
        </Group>
      </ContentSkeletonSection>
    </DealSkeletonContainer>
  )
}

function CruiseDealsListSkeleton() {
  const skeletonItems = [...Array(6)].map((_, index) => (
    <DealSkeletonItem key={index} />
  ))

  return (
    <Sheet padding="20 0" tabletPadding="32 0">
      <LayoutContainer>
        <Group direction="vertical" gap={32} tabletGap={48}>
          <Group direction="vertical" gap={8} horizontalAlign="center">
            <TitleLoadingBox />
            <SubtitleLoadingBox />
          </Group>

          <SkeletonGrid>
            {skeletonItems}
          </SkeletonGrid>
        </Group>
      </LayoutContainer>
    </Sheet>
  )
}

export default CruiseDealsListSkeleton
